__turbopack_context__.v({
  "banner": "styles-module-scss-module__3zRnwW__banner",
  "description": "styles-module-scss-module__3zRnwW__description",
  "title": "styles-module-scss-module__3zRnwW__title",
});
